import {h, Component} from 'preact';
import Item from './Item';
import MediaItem from './MediaItem';

class Menu extends Component {

    static item = Item;
    static mediaItem = MediaItem;

    render( props = {menuItems: [], style: {}} ) {
        return (
            <nav style={props.style}
                 className="nav-submenu hidden absolute border-l border-grey-lighter overflow-y-auto">
                <ul className="list-reset m-0">
                    {props.menuItems.map( renderMenuItem )}
                </ul>
            </nav>)
    };
}

function renderMenuItem( node ) {
    const Component = /chemistries/.test( node.url )
        ? Menu.mediaItem
        : Menu.item;

    return <Component {...node} />;
}

export default Menu;